exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Z_uZed8IP542glYID7Elk{margin-top:2rem}._1Al6uXJmuGEQbk65VShAsr{margin-top:2.67rem}.Ime1XF2dvC_eRkm7k2_xC{height:auto}", "", {"version":3,"sources":["/var/www/fsa/skopei-portal/src/containers/User/Login/Login.scss"],"names":[],"mappings":"AAYA,uBACE,eAAiB,CAAE,AACnB,yBACE,kBAAoB,CAAE,AAE1B,uBACE,WAAa,CAAE","file":"Login.scss","sourcesContent":["/* * * * * * * * *\n * NAMED COLORS  *\n * * * * * * * * */\n/* * * * * * * * * * *\n * INTERFACE COLORS  *\n * * * * * * * * * * */\n/* * * * * * * * *\n * BRAND COLORS  *\n * * * * * * * * */\n/* * * * * * * * * * * * * * *\n * SET DEFAULT BRAND COLORS  *\n * * * * * * * * * * * * * * */\n.login__footer {\n  margin-top: 2rem; }\n  .login__footer__logo {\n    margin-top: 2.67rem; }\n\n.login__remember__label {\n  height: auto; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"login__footer": "Z_uZed8IP542glYID7Elk",
	"login__footer__logo": "_1Al6uXJmuGEQbk65VShAsr",
	"login__remember__label": "Ime1XF2dvC_eRkm7k2_xC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"sourceMap":true,"importLoaders":2}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/containers/User/Login/Login.scss
// module id = 736
// module chunks = 14